import { conditions } from "../../helpers/conditions/conditions";
import { handleRipple, responseValidator } from "../../helpers/helpers";
import { ConditionName, ContentTypesString } from "../../interfaces/enums";
import { get, getAll } from "../../services/apiCaller";
import { API } from "../../services/services";
import { setPlayListCardPopover, setTagsPopover } from "../slices/popoversSlice";
import store from "../store";
import { searchLog, searchResultClickLog, tagClickLog } from "../../logs/logs";
import {
    setInputFilterTagSearch,
    setInputTagSearch,
    setIsMovieFilter,
    setIsSeriesFilter,
    setSelectedTags,
    setViewersTagsList
} from "../slices/tagsSlice";
import { sendFluentLog } from "../../logs/fluentdLogger";
import { handleContentType } from "./videoData.actions";

export const getFitMaxNumberCard = () => Math.ceil((window.innerWidth * window.innerHeight) / (265 * 149));

export const handleGetTags = (
    scrollEnd: boolean,
    setScrollEnd: (scrollEnd: boolean) => void,
    listScrolled: any[],
    setListScrolled: (listScrolled: any[]) => void
) => {
    const { details, params } = store.getState().videoData;
    const { selectedTags, inputTagSearch } = store.getState().tags;
    if (scrollEnd && listScrolled.length) {
        get(
            (response: any, status: any) => {
                if (responseValidator(status)) {
                    if (response.results.length > 0) setListScrolled(listScrolled.concat(response.results));
                    setScrollEnd(false);
                }
            },
            API().searchViewers,
            {
                tag: selectedTags.join(","),
                q: conditions(ConditionName.hasInputTagSearch) ? inputTagSearch : undefined,
                user_ids: conditions(ConditionName.isUserIdsParamsEqualAll)
                    ? undefined
                    : conditions(ConditionName.hasUserIds)
                    ? params.user_ids
                    : details.user_id,
                limit: conditions(ConditionName.isComplexPortrait) ? 10 : getFitMaxNumberCard(),
                offset: listScrolled.length
            }
        );
    }
};

export const handleClickTag = (
    setVideoCount: (videoCount: number) => void,
    listScrolled: any[],
    setListScrolled: (listScrolled: any[]) => void,
    setLoadingGetTags?: (value: boolean) => void
) => {
    const dispatch = store.dispatch;
    const { details, params } = store.getState().videoData;
    const { selectedTags, inputTagSearch } = store.getState().tags;
    const contentType = handleContentType();
    sendFluentLog(searchLog(contentType));
    if (setLoadingGetTags) setLoadingGetTags(true);
    get(
        (response: any, status: any) => {
            if (responseValidator(status)) {
                setVideoCount(response.count);
                if (response.results.length > 0) {
                    dispatch(setTagsPopover(true));
                    setListScrolled(response.results);
                } else setListScrolled([]);
            }
            if (setLoadingGetTags) setLoadingGetTags(false);
        },
        API().searchViewers,
        {
            tag: selectedTags.join(","),
            q: conditions(ConditionName.hasInputTagSearch) ? inputTagSearch : undefined,
            user_ids: conditions(ConditionName.isUserIdsParamsEqualAll)
                ? undefined
                : conditions(ConditionName.hasUserIds)
                ? params.user_ids
                : details.user_id,
            limit: listScrolled.length + (conditions(ConditionName.isComplexPortrait) ? 10 : getFitMaxNumberCard()),
            offset: 0,
            video_type: contentType
        }
    );
};

export const handleClickPlayerCardTag = (event: any, tag: string) => {
    const dispatch = store.dispatch;
    const { selectedTags } = store.getState().tags;
    event.preventDefault();
    event.stopPropagation();
    if (!selectedTags.includes(tag)) {
        dispatch(setPlayListCardPopover(false));
        dispatch(setTagsPopover(true));
        dispatch(setSelectedTags([...selectedTags, tag]));
        sendFluentLog(tagClickLog(tag.trim()));
    }
};

export const getAllViewersTagList = async () => {
    const { details, params } = store.getState().videoData;
    const { selectedTags } = store.getState().tags;
    return new Promise(async (resolve) => {
        try {
            const data = await getAll(API().viewersTagList(params.type!), [], {
                user_ids: conditions(ConditionName.isUserIdsParamsEqualAll)
                    ? undefined
                    : conditions(ConditionName.hasUserIds)
                    ? params.user_ids
                    : details.user_id,
                tag: selectedTags.join(",")
            });
            resolve(data);
        } catch (error) {}
    });
};

export const handleViewersTagList = async () => {
    const dispatch = store.dispatch;
    const { selectedTags } = store.getState().tags;

    const results: any = await getAllViewersTagList();
    if (results) {
        let viewersTagList: string[] = [];
        results.map((result: any) => viewersTagList.push(result.tag.trim()));
        viewersTagList = [...new Set(viewersTagList)];
        dispatch(setViewersTagsList(viewersTagList.filter((tag: string) => tag !== selectedTags[0])));
    }
};

export const handleCloseTagPopover = () => {
    const dispatch = store.dispatch;
    dispatch(setTagsPopover(false));
    dispatch(setSelectedTags([]));
    dispatch(setInputTagSearch(""));
    dispatch(setIsMovieFilter(false));
    dispatch(setIsSeriesFilter(false));
    dispatch(setInputFilterTagSearch(""));
};

export const handleTagInput = (
    inputValue: string,
    setTagInputLoading: (tagInputLoading: boolean) => void,
    tagInputTimeoutRef: any,
    setVideoCount: (videoCount: number) => void,
    listScrolled: any[],
    setListScrolled: (listScrolled: any[]) => void,
    setLoadingGetTags: (value: boolean) => void
) => {
    const dispatch = store.dispatch;
    dispatch(setInputTagSearch(inputValue));
    setTagInputLoading(true);
    clearTimeout(tagInputTimeoutRef.current);
    tagInputTimeoutRef.current = setTimeout(() => {
        handleClickTag(setVideoCount, listScrolled, setListScrolled, setLoadingGetTags);
        setTagInputLoading(false);
    }, 500);
};

export const handleCloseSelectedTags = (tag: string) => {
    const dispatch = store.dispatch;
    const { selectedTags, viewersTagsList } = store.getState().tags;

    dispatch(setSelectedTags(selectedTags.filter((selectedTag: string) => selectedTag !== tag)));
    dispatch(setViewersTagsList([tag, ...viewersTagsList]));
};

export const handleClickViewersTagList = (tag: string) => {
    const dispatch = store.dispatch;
    const { selectedTags, viewersTagsList } = store.getState().tags;
    dispatch(setSelectedTags([...selectedTags, tag]));
    dispatch(setViewersTagsList(viewersTagsList.filter((viewerTag: string) => viewerTag !== tag)));
};

export const handleClearTagInput = (
    setVideoCount: (videoCount: number) => void,
    listScrolled: any[],
    setListScrolled: (listScrolled: any[]) => void
) => {
    const dispatch = store.dispatch;
    dispatch(setInputTagSearch(""));
    handleClickTag(setVideoCount, listScrolled, setListScrolled);
};

export const handleNextTag = (e: any, tagsContainerRef: any) => {
    e.preventDefault();
    e.stopPropagation();
    tagsContainerRef.current.scrollLeft -= tagsContainerRef.current.clientWidth;
};

export const handlePrevTag = (e: any, tagsContainerRef: any) => {
    e.preventDefault();
    e.stopPropagation();
    tagsContainerRef.current.scrollLeft += tagsContainerRef.current.clientWidth;
};

export const handleScrollLeft = (event: any, tagId: string) => {
    event.preventDefault();
    event.stopPropagation();
    const element = document.getElementById(tagId);
    if (element) element.scrollLeft -= 50;
};

export const handleScrollRight = (event: any, tagId: string) => {
    event.preventDefault();
    event.stopPropagation();
    const element = document.getElementById(tagId);
    if (element) element.scrollLeft += 50;
};

export const handleSearchResultClick = (event: any, video: any, playListCardInfoRef: any, videoId: number, videoType: string, videoIndex: number) => {
    const dispatch = store.dispatch;
    handleRipple(event, `tagVideoList-${videoId}`, 150);
    if (videoType === ContentTypesString.PlayList) {
        dispatch(setPlayListCardPopover(true));
        playListCardInfoRef.current = video;
    } else sendFluentLog(searchResultClickLog(videoId, videoType, videoIndex));
};
